// Styles
import "./empty-list.scss";
// Tools
import gsap from "gsap";
import { useRef, useEffect } from "react";

interface Props {
	image: string; // Ссыдка на изображение
	text: string;
}

export const EmptyList = ({ image, text }: Props) => {
	const element = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		gsap.fromTo(
			element.current,
			{
				opacity: 0,
				y: 10,
				scale: 0.98,
			},
			{
				opacity: 1,
				y: 1,
				scale: 1,
				duration: 0.3,
			},
		);
	}, []);

	return (
		<div ref={element} className='empty-list'>
			<div className='empty-list__wrapper'>
				<img src={`${image}`} alt='' />
				<div className='empty-list__text'>{text}</div>
			</div>
		</div>
	);
};
